import { MatLabel } from '@angular/material/form-field';
import { Component, OnInit, Injector, ChangeDetectionStrategy } from '@angular/core';
import { ActivateAccountComponent } from '@mango/activate-account';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LayoutDirective, LayoutAlignDirective } from '@ngbracket/ngx-layout/flex';
import { MatCard, MatCardTitle, MatCardContent } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput, MatSuffix } from '@angular/material/input';
import { MgFormControlDirective } from '@mango/core';
import { MatIconButton, MatButton } from '@angular/material/button';

@Component({
    selector: 'suselbeek-activate-account',
    templateUrl: './activate-account.component.html',
    styleUrls: ['./activate-account.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, LayoutDirective, LayoutAlignDirective, MatCard, MatCardTitle, MatCardContent, MatIcon, MatFormField, MatLabel, MatInput, MgFormControlDirective, MatIconButton, MatSuffix, MatButton]
})
export class SuselbeekActivateAccountComponent extends ActivateAccountComponent implements OnInit {

    randomNumber: number;
    backgroundPictureCount: number = 7;

    constructor(injector: Injector) { 
        super();

        this.randomNumber = Math.floor(Math.random() * this.backgroundPictureCount) + 1
    }
    

    getRandomBackground(): string {
        return `assets/login-photos/${this.randomNumber}.jpg`;
    }

}
